interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav aria-label="章节分页" className="mt-8 flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 font-label text-xs text-foreground-700 transition-colors enabled:cursor-pointer enabled:hover:border-accent-500 enabled:hover:text-accent-400 disabled:opacity-35"
      >
        <i className="ri-arrow-left-s-line text-base leading-none" />
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`h-9 w-9 cursor-pointer rounded-md font-label text-xs transition-colors ${
            item === page
              ? "bg-accent-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-accent-500 hover:text-accent-400"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 font-label text-xs text-foreground-700 transition-colors enabled:cursor-pointer enabled:hover:border-accent-500 enabled:hover:text-accent-400 disabled:opacity-35"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base leading-none" />
      </button>
    </nav>
  );
}